<app-organization-menu [id]="currentOrganizationId"></app-organization-menu>
<div class="container pt-4" style="padding-bottom: 150px;">
    <div class="row">
        <div class="col">
            <h4 class="border-bottom pb-2 color-primary mb-3">{{'ORGANIZATION.EVENTS.UPDATE.createEventTitle' | translate}}
                <small class="form-text text-muted pl-2" style="font-size: 12px; display: block;">
                    {{'ORGANIZATION.EVENTS.UPDATE.createEventHelpText' | translate}}
                </small>
            </h4>
        </div>
    </div>
    <div class="row">
        <div class="col-12 offset-sm-5 col-sm-7 text-end">
            <select class="form-select form-select-sm mb-2" #languageSelect
                (change)="onLanguageChange(languageSelect.value)" [(ngModel)]="currentOrgLanguage">
                <option value="de">{{'GENERAL.german' | translate}}</option>
                <option value="it">{{'GENERAL.italian' | translate}}</option>
                <option value="en">{{'GENERAL.english' | translate}}</option>
            </select>
            <p class="form-text text-muted m-0" [innerHTML]="'ORGANIZATION.INFORMATIONS.mandatoryHelpText' | translate">
            </p>
        </div>
    </div>
    <form #eventForm="ngForm" id="eventForm" [formGroup]="eventFormGroup" class="mt-3">
        <div class="form-group row">
            <div class="col">
                <label class="m-0 col-form-label">
                    {{'ORGANIZATION.EVENTS.UPDATE.eventType' | translate}} *</label>
            </div>
            <div class="col-sm-9">
                <select class="form-select form-select-sm mb-2" formControlName="eventTypeId">
                    <option [value]="eventType.id" *ngFor="let eventType of eventTypes">
                        {{eventType['name_'+currentLang]}}</option>
                </select>
                <span class="small form-text text-danger block"
                    *ngIf="eventFormGroup.get('eventTypeId').hasError('required')">
                    {{'GENERAL.required' | translate}}</span>
            </div>
        </div>
        <div class="form-group row">
            <div class="col">
                <label class="m-0">{{'ORGANIZATION.EVENTS.UPDATE.name' | translate}}
                    *</label>
                <p class="form-text text-muted m-0">{{languageToString[currentOrgLanguage]}}</p>
            </div>
            <div class="col-sm-9">
                <ng-container [ngSwitch]="currentOrgLanguage">
                    <ng-container *ngSwitchCase="'de'">
                        <input type="text" class="form-control form-control-sm" id="name_de" name="name_de"
                            formControlName="name_de">
                    </ng-container>
                    <ng-container *ngSwitchCase="'en'">
                        <input type="text" class="form-control form-control-sm" id="name_en" name="name_en"
                            formControlName="name_en">
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <input type="text" class="form-control form-control-sm" id="name_it" name="name_it"
                            formControlName="name_it">
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <!--
        // 16/05/2022 - Commented because Evelyn says it's not needed location: event is always inside the swimmingpool
        <div class="form-group row">
            <div class="col">
                <label for="inputEmail3" class="m-0">{{'ORGANIZATION.EVENTS.UPDATE.location' | translate}}
                    *</label>
                <p class="form-text text-muted m-0">{{languageToString[currentOrgLanguage]}}</p>
            </div>
            <div class="col-sm-9">
                <ng-container [ngSwitch]="currentOrgLanguage">
                    <ng-container *ngSwitchCase="'de'">
                        <input type="text" class="form-control form-control-sm" id="location_de" name="location_de"
                            formControlName="location_de">
                    </ng-container>
                    <ng-container *ngSwitchCase="'en'">
                        <input type="text" class="form-control form-control-sm" id="location_en" name="location_en"
                            formControlName="location_en">
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <input type="text" class="form-control form-control-sm" id="location_it" name="location_it"
                            formControlName="location_it">
                    </ng-container>
                </ng-container>
            </div>
        </div>
        -->
        <div class="form-group row">
            <div class="col">
                <label class="m-0 col-form-label">{{'ORGANIZATION.EVENTS.UPDATE.startDate' | translate}}
                    *</label>
            </div>
            <div class="col-sm-9">
                <div class="input-group input-group-sm mb-3">
                    <input class="form-control " placeholder="yyyy-mm-dd" name="startDate" ngbDatepicker
                        #startDatepicker="ngbDatepicker" formControlName="startDate" readonly>
                    <button class="btn btn-outline-secondary" (click)="startDatepicker.toggle()" type="button">
                        <fa-icon [icon]="icons['faCalendarAlt']"></fa-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col">
                <label class="m-0 col-form-label">{{'ORGANIZATION.EVENTS.UPDATE.endDate' | translate}}
                    *</label>
            </div>
            <div class="col-sm-9">
                <div class="input-group input-group-sm mb-3">
                    <input class="form-control " placeholder="yyyy-mm-dd" name="endDate" ngbDatepicker
                        #endDatepicker="ngbDatepicker" formControlName="endDate" readonly>
                    <button class="btn btn-outline-secondary" (click)="endDatepicker.toggle()" type="button">
                        <fa-icon [icon]="icons['faCalendarAlt']"></fa-icon>
                    </button>
                </div>
                <span class="small form-text text-danger text-center" *ngIf="endDateBeforeStartDateError">
                    {{'ORGANIZATION.EVENTS.UPDATE.endDateBeforeStartDateError' | translate}}
                </span>
            </div>
        </div>
        <div class="form-group row">
            <div class="col">
                <label class="m-0">{{'ORGANIZATION.EVENTS.UPDATE.generalDescription' | translate}}
                </label>
                <p class="form-text text-muted m-0">{{languageToString[currentOrgLanguage]}}</p>
            </div>
            <div class="col-sm-9">
                <ng-container [ngSwitch]="currentOrgLanguage">
                    <ng-container *ngSwitchCase="'de'">
                        <quill-editor id="description_de" name="description_de" formControlName="description_de"
                            [styles]="{height: '250px'}">
                        </quill-editor>
                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                [icon]="icons['faLink']"></fa-icon>
                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                    </ng-container>
                    <ng-container *ngSwitchCase="'en'">
                        <quill-editor id="description_en" name="description_en" formControlName="description_en"
                            [styles]="{height: '250px'}">
                        </quill-editor>
                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                [icon]="icons['faLink']"></fa-icon>
                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <quill-editor id="description_it" name="description_it" formControlName="description_it"
                            [styles]="{height: '250px'}">
                        </quill-editor>
                        <small class="text-muted">{{'GENERAL.richTextFielHelpText' | translate}} <fa-icon
                                [icon]="icons['faLink']"></fa-icon>
                            {{'GENERAL.richTextFielHelpText2' | translate}}</small>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <!--  -->
        <div class="form-group row mt-3">
            <div class="col">
                <label class="m-0 col-form-label">
                    {{'ORGANIZATION.EVENTS.UPDATE.eventHour' | translate}} *
                </label>
            </div>
            <div class="col-sm-9">
                <ng-container
                    *ngIf="eventFormGroup.get('eventTypeId').value === '7'">
                    <p *ngIf="eventFormGroupFormArray.length === 0">
                        {{'ORGANIZATION.EVENTS.UPDATE.missingStartEndDate' | translate}}</p>
                    <table class="table table-bordered" *ngIf="eventFormGroupFormArray.length > 0">
                        <thead>
                            <tr>
                                <th scope="col">{{'ORGANIZATION.EVENTS.UPDATE.date' | translate}}</th>
                                <th scope="col">{{'ORGANIZATION.EVENTS.UPDATE.startHours' | translate}}</th>
                                <th scope="col">{{'ORGANIZATION.EVENTS.UPDATE.endHours' | translate}}</th>
                                <!-- <th scope="col">Handle</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr [formGroup]="formGroup"
                                *ngFor="let formGroup of eventFormGroupFormArray; let i = index">
                                <th scope="row">{{formGroup.get('eventDate').value}}</th>
                                <td><input class="form-control form-control-sm" type="text" formControlName="startHour">
                                </td>
                                <td><input class="form-control form-control-sm" type="text" formControlName="endHour">
                                </td>
                                <!-- <td>@mdo</td> -->
                            </tr>
                        </tbody>
                    </table>
                </ng-container>
                <ng-container
                    *ngIf="eventFormGroup.get('eventTypeId').value === '8'">
                    <div class="table-responsive">
                        <table class="table table-bordered table-sm m-0 border-0 p-1">
                            <thead>
                                <tr>
                                    <th scope="col">{{'ORGANIZATION.EVENTS.UPDATE.startHours' | translate}}</th>
                                    <th scope="col">{{'ORGANIZATION.EVENTS.UPDATE.endHours' | translate}}</th>
                                    <th style="width: 4%;">{{'ORGANIZATION.EVENTS.UPDATE.mon' | translate}}</th>
                                    <th style="width: 4%;">{{'ORGANIZATION.EVENTS.UPDATE.tue' | translate}}</th>
                                    <th style="width: 4%;">{{'ORGANIZATION.EVENTS.UPDATE.wed' | translate}}</th>
                                    <th style="width: 4%;">{{'ORGANIZATION.EVENTS.UPDATE.thu' | translate}}</th>
                                    <th style="width: 4%;">{{'ORGANIZATION.EVENTS.UPDATE.fri' | translate}}</th>
                                    <th style="width: 4%;">{{'ORGANIZATION.EVENTS.UPDATE.sat' | translate}}</th>
                                    <th style="width: 4%;">{{'ORGANIZATION.EVENTS.UPDATE.sun' | translate}}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr [formGroup]="formGroup"
                                    *ngFor="let formGroup of eventFormGroupFormArray; let i = index">
                                    <td><input class="form-control form-control-sm" type="text"
                                            formControlName="startHour">
                                    </td>
                                    <td><input class="form-control form-control-sm" type="text"
                                            formControlName="endHour">
                                    </td>
                                    <ng-container formGroupName="openingDays">
                                        <td>
                                            <div>
                                                <input type="checkbox" class="form-check-input form-control"
                                                    formControlName="1"
                                                    style="margin: 0 auto; width: 100%; height: 30px;" />
                                            </div>
                                        </td>
                                        <td>
                                            <input type="checkbox" class="form-check-input form-control"
                                                formControlName="2"
                                                style="margin: 0 auto; width: 100%; height: 30px;" />
                                        </td>
                                        <td>
                                            <input type="checkbox" class="form-check-input form-control"
                                                formControlName="3"
                                                style="margin: 0 auto; width: 100%; height: 30px;" />
                                        </td>
                                        <td>
                                            <input type="checkbox" class="form-check-input form-control"
                                                formControlName="4"
                                                style="margin: 0 auto; width: 100%; height: 30px;" />
                                        </td>
                                        <td>
                                            <input type="checkbox" class="form-check-input form-control"
                                                formControlName="5"
                                                style="margin: 0 auto; width: 100%; height: 30px;" />
                                        </td>
                                        <td>
                                            <input type="checkbox" class="form-check-input form-control"
                                                formControlName="6"
                                                style="margin: 0 auto; width: 100%; height: 30px;" />
                                        </td>
                                        <td>
                                            <input type="checkbox" class="form-check-input form-control"
                                                formControlName="7"
                                                style="margin: 0 auto; width: 100%; height: 30px;" />
                                        </td>
                                    </ng-container>
                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-danger"
                                            (click)="deleteScheduleTimeControl(i)">
                                            <fa-icon [icon]="icons['faTimes']">
                                            </fa-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="11" class="text-center">
                                        <button type="button" class="btn btn-sm btn-outline-primary"
                                            (click)="onAddTimeScheduleElement()">
                                            {{'ORGANIZATION.EVENTS.UPDATE.addSchedules' | translate}}
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="form-group row mt-3">
            <div class="col">
                <label class="m-0 col-form-label">{{'ORGANIZATION.EVENTS.UPDATE.imagesUpdload' | translate}}</label>
            </div>
            <div class="col-sm-9">
                <div class="row" *ngIf="eventFormGroup.get('id').value">
                    <div class="col text-center">
                        <ng-container *ngIf="eventImages.length > 0; else elseTemplate">
                            <div class="row row-cols-1 row-cols-md-3 g-4">
                                <div class="col" *ngFor="let image of eventImages; let i = index">
                                    <div class="card h-100 text-center">
                                        <div class="card-body">
                                            <img [src]="imageUrl + image.filePath" class="img-fluid"
                                                style="width: 70%; margin: 0 auto;" [alt]="image.fileName">
                                        </div>
                                        <div class="card-footer">
                                            <button type="button" class="btn btn-sm btn-outline-danger me-1"
                                                (click)="deleteImage(image.id, i)">{{'GENERAL.delete' |
                                                translate}}</button>
                                            <button type="button" class="btn btn-sm btn-outline-warning"
                                                *ngIf="!image.isMain" (click)="setImageAsMain(image.id, i)">
                                                {{'ORGANIZATION.EVENTS.UPDATE.setAsMainImage' | translate}}
                                            </button>
                                            <span *ngIf="image.isMain">
                                                {{'ORGANIZATION.EVENTS.UPDATE.isMainImage' | translate}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #elseTemplate>
                            <img class="img-fluid img-thumbnail" style="height: 200px"
                                [src]="'assets/images/standard-picture-vss.png'" />
                        </ng-template>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="custom-file mt-2">
                            <div class="mb-3">
                                <label class="form-label">{{'ORGANIZATION.EVENTS.UPDATE.browse' |
                                    translate}}</label>
                                <input class="form-control form-control-sm" type="file" id="customFile"
                                    (change)="handleImageFileInput($event)">
                            </div>
                            <small class="help-text text-danger" *ngIf="fileSizeError">
                                {{'ORGANIZATION.INFORMATIONS.fileSizeError' | translate}}
                            </small>
                        </div>
                        <p class="form-text text-muted">
                            {{'ORGANIZATION.INFORMATIONS.uploadHelpText' | translate}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>
<nav class="navbar fixed-bottom navbar-expand-sm navbar-white bg-white" style="border-top: 1px solid #3f51b5;">
    <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav me-auto" style="margin: 0 auto;">
            <li class="nav-item text-center">
                <button type="button" class="btn btn-outline-primary" (click)="submitForm()">{{'GENERAL.save' |
                    translate}}</button>
            </li>
        </ul>
    </div>
</nav>
<app-toast></app-toast>
